import { render, staticRenderFns } from "./divider.vue?vue&type=template&id=5235623c&scoped=true"
import script from "./divider.vue?vue&type=script&lang=js"
export * from "./divider.vue?vue&type=script&lang=js"
import style0 from "./divider.vue?vue&type=style&index=0&id=5235623c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5235623c",
  null
  
)

/* custom blocks */
import block0 from "./divider.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports